import { useEffect, useState } from 'react'

export const useScreenOrientation = () => {
  const [orientationType, setOrientationType] = useState(screen.orientation.type)

  const isPortrait = orientationType.startsWith('portrait')
  const isLandscape = orientationType.startsWith('landscape')

  useEffect(() => {
    const handleOrientationChange = () => {
      setOrientationType(screen.orientation.type)
    }

    screen.orientation.addEventListener('change', handleOrientationChange)

    return () => {
      screen.orientation.removeEventListener('change', handleOrientationChange)
    }
  }, [])

  return {
    isLandscape,
    isPortrait,
    orientationType,
  }
}
